import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { connectRouter } from 'connected-react-router';

import { store } from './redux/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import i18n from './locales/i18n';
import { I18nextProvider } from 'react-i18next';
import { CustomRouter } from 'routers/CustomRouter';
import customHistory from 'utils/customHistory';

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  // <React.StrictMode>
  //   <I18nextProvider i18n={i18n}>
  //     <Provider store={store}>
  //       <CustomRouter history={customHistory}>
  //         <App />
  //       </CustomRouter>
  //     </Provider>
  //   </I18nextProvider>
  // </React.StrictMode>
  <I18nextProvider i18n={i18n}>
    <Provider store={store}>
      <CustomRouter history={customHistory}>
        <App />
      </CustomRouter>
    </Provider>
  </I18nextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
